import Head from "next/head"
import { useMutation } from "@blitzjs/rpc"
import { BlitzPage } from "@blitzjs/next"
import Layout from "app/core/layouts/Layout"
import Box from "@mui/material/Box"
import { styled } from "@mui/material/styles"
import { useState, useEffect } from "react"
import generateAnalyticsEmbedUrl from "app/analytics/mutations/generateAnalyticsEmbedUrl"

const Iframe = styled("iframe")``

const AnalyticsPage: BlitzPage = () => {
  const [src, setSrc] = useState<string | null>(null)
  const [generateAnalyticsEmbedUrlMutation] = useMutation(generateAnalyticsEmbedUrl)

  useEffect(() => {
    generateAnalyticsEmbedUrlMutation()
      .then((url) => {
        setSrc(url || null)
      })
      .catch((error) => {
        console.error(error)
        setSrc(null)
      })
  }, [generateAnalyticsEmbedUrlMutation])

  return (
    <>
      <Head>
        <title>Analytics</title>
      </Head>

      <Box
        sx={{
          // border: "1px solid red",
          position: "absolute",
          top: 64,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        {src && <Iframe src={src} sx={{ width: "100%", height: "100%", border: "none" }} />}
      </Box>
    </>
  )
}

AnalyticsPage.authenticate = true
AnalyticsPage.getLayout = (page) => <Layout>{page}</Layout>

export default AnalyticsPage
